import { createFileRoute } from "@tanstack/react-router";

import { NotificationSettings } from "@/features/settings/NotificationSettings";

export const Route = createFileRoute("/_app/settings/notifications")({
  component: NotificationSettings,
});
